import React from 'react';

function Fill({ size, strokeWidth, fill = 'currentColor', stroke, ...otherProps }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 24 24"
      strokeLinecap="round"
      strokeLinejoin="round"
      {...otherProps}
    >
      <path
        className="ws-icon--fill"
        fill={fill}
        stroke="none"
        d="M8.89961298,9.6496 L13.522013,11.1904 C13.7850012,11.2782173 13.9837676,11.4959445 14.0473262,11.7658241 C14.1108848,12.0357036 14.030172,12.3192503 13.834013,12.5152 L10.224413,16.1248 C9.59961321,16.7494111 8.58681274,16.7494111 7.96201298,16.1248 L5.69961298,13.8624 C5.07500187,13.2376002 5.07500187,12.2247998 5.69961298,11.6 L7.26281298,10.0368 C7.69109346,9.60823584 8.32470936,9.45834821 8.89961298,9.6496 Z M18.224413,18.8 C18.224413,17.9168 19.024413,16.5824 20.624413,14.8 C22.224413,16.5824 23.024413,17.9168 23.024413,18.8 C23.024413,20.1254834 21.9498964,21.2 20.624413,21.2 C19.2989296,21.2 18.224413,20.1254834 18.224413,18.8 Z"
      />
      <path
        className="ws-icon--stroke"
        stroke={stroke}
        strokeWidth={strokeWidth}
        fill="none"
        d="M8.36690889,19.9267468 L1.88290682,13.4577207 C1.49194109,13.0676615 1.49119288,12.4345199 1.88123561,12.0435378 L10.6089773,3.29471704 C10.9978283,2.90492958 11.628612,2.90279425 12.020093,3.28994014 L18.5754929,9.77274738 C18.9681854,10.1610913 18.9717106,10.7942465 18.5833667,11.186939 C18.5812049,11.1891251 18.579033,11.1913011 18.5768511,11.1934671 L9.77771151,19.9285067 C9.38709641,20.3162763 8.75655532,20.3154897 8.36690889,19.9267468 Z"
      />
    </svg>
  );
}

export default Fill;
